import React from "react";
import { Input } from "@revvsales/components";
import {
  RevvForm,
  // ErrorMessages,
  ReactSelect,
} from "../../../../commonComponents";

import {
  CustomFieldComponentRules,
  CustomFieldComponentMessages,
} from "../../DynamicField/DynamicFieldComponents/CustomFieldRulesMap";

export default class RateFormMode extends React.Component {
  state = {
    // eslint-disable-next-line no-nested-ternary
    rateFieldValues: this.props.initialProps.value
      ? JSON.parse(JSON.stringify(this.props.initialProps.value))
      : this.props.initialProps.meta && this.props.initialProps.meta.default
      ? JSON.parse(JSON.stringify(this.props.initialProps.meta.default))
      : { rateUom: "month(s)", rateValue: 10 },
  };

  _handleOnBlur = (event, value, handleBlur, isValidated) => {
    handleBlur(event);
    // If there is a value then only
    // make an API call and update the redux store
    const updatedValue = {
      ...value,
      rateValue: parseInt(value.rateValue, 10),
    };
    if (isValidated && value.rateValue) {
      const { id } = this.props.initialProps;
      const { rateValue, rateUom } = value;
      const combinedValue = `${rateValue} ${rateUom}`;
      if (!combinedValue.split(" ").includes("")) {
        this.props._updateDynamicFieldsInDoc(id, updatedValue);
      }
      this._checkForRateValueUpdateField(updatedValue, combinedValue);
    }
  };

  _handleOnChange = (value, defaultValue, handleChangeByName) => {
    handleChangeByName(value, "rateUom");
    // If there is a value then only
    // make an API call and update the redux store
    const updatedValue = {
      ...defaultValue,
      rateValue: parseInt(defaultValue.rateValue, 10),
    };
    if (defaultValue.rateUom) {
      const { id } = this.props.initialProps;
      const { rateValue, rateUom } = defaultValue;
      const combinedValue = `${rateValue} ${rateUom}`;
      if (!combinedValue.split(" ").includes("")) {
        this.props._updateDynamicFieldsInDoc(id, updatedValue);
      }
      this._checkForRateUomUpdateField(updatedValue, combinedValue);
    }
  };

  _checkForRateValueUpdateField = (currentValue, combinedValue) => {
    const { id, value: initialValue } = this.props.initialProps;
    if (initialValue.rateValue !== currentValue.rateValue) {
      this.props._updateField(id, currentValue.rateValue, "rateValue");
      this._checkChangeStatus(combinedValue);
    }
  };

  _checkForRateUomUpdateField = (currentValue, combinedValue) => {
    const { id, value: initialValue } = this.props.initialProps;
    if (initialValue.rateUom !== currentValue.rateUom) {
      this.props._updateField(id, currentValue.rateUom, "rateUom");
      this._checkChangeStatus(combinedValue);
    }
  };

  _checkChangeStatus = value => {
    this.props.filledStatus(!value.split(" ").includes(""));
  };

  render() {
    const { id, /* docIsLocked */ meta } = this.props.initialProps;
    return (
      <React.Fragment>
        <RevvForm
          revvFormId={id}
          initialFormValue={this.state.rateFieldValues}
          customFieldName="RATE"
          customFieldComponentRules={CustomFieldComponentRules}
          validateOnChange
          customFieldComponentMessages={CustomFieldComponentMessages}
          render={formProps => {
            const {
              handleChangeByName,
              handleChange,
              handleBlur,
              messages,
              values,
            } = formProps;
            return (
              <React.Fragment>
                <div className="composite-field-period">
                  <div className="composite-field-period-val">
                    <Input
                      id={id}
                      name="rateValue"
                      type="number"
                      className="form-mode-input"
                      // {`form-mode-input ${
                      //   messages.rateValue && messages.rateValue.required !== ""
                      //     ? "danger-border"
                      //     : ""
                      // }`}
                      placeholder="Enter period value"
                      value={values.rateValue}
                      onChange={event => handleChange(event)}
                      onBlur={event =>
                        this._handleOnBlur(
                          event,
                          values,
                          handleBlur,
                          !messages.rateValue,
                        )
                      }
                      disabled={this.props.isLocked}
                      autoFocus
                      data-test="period-value-field-form-mode"
                    />
                    {/* <div>
                      {messages.rateValue && (
                        <ErrorMessages messages={messages.rateValue.required} />
                      )}
                    </div> */}
                  </div>

                  <div className="composite-field-period-uom">
                    <ReactSelect
                      id={id}
                      name="rateUom"
                      isSearchable
                      options={meta.options}
                      value={values.rateUom}
                      onChange={event =>
                        this._handleOnChange(
                          event.value,
                          values,
                          handleChangeByName,
                        )
                      }
                      isDisabled={this.props.isLocked}
                      data-test="period-uom-field-form-mode"
                    />
                  </div>
                </div>
              </React.Fragment>
            );
          }}
        />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DocumentV2/FormView/FormModeComponents/RateFormMode.js